import React, { PropsWithChildren } from 'react';

import { AppContent } from './App.content';
import {
  ForceUpdateMode,
  MaintenanceMode,
  useIsForceUpdateModeEnabled,
  useIsMaintenanceModeEnabled,
} from './components';
import { use3rdPartyIntegrations } from './hooks';

// ────────────────────────────────────────────────────────────────────────────────

/**
 * Renders the post-gate render branches: force-update mode, maintenance mode,
 * or the regular app content. The launch-time gate (and the in-flight restart
 * loading state) is owned by `LaunchGate` upstream.
 */
export const App = (props: PropsWithChildren) => {
  const { children } = props;

  const isMaintenanceModeEnabled = useIsMaintenanceModeEnabled();
  const isForceUpdatedModeEnabled = useIsForceUpdateModeEnabled();

  use3rdPartyIntegrations();

  // ─────────────────────────────────────────────────────────────────────

  if (isForceUpdatedModeEnabled) return <ForceUpdateMode />;

  if (isMaintenanceModeEnabled) return <MaintenanceMode />;

  return <AppContent>{children}</AppContent>;
};
